"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "en": {
        "translation": {
            "left_navigation": {
                "loading": "Loading",
                "hidden_target": "Your selection cannot be displayed due to your applied filter(s). To display the item, remove the appropriate filter(s).",
                "sidenav_open": "Open navigation",
                "sidenav_close": "Close navigation",
                "expand": "Expand",
                "collapse": "Collapse",
                "small_search": "Please type at least 2 characters to search.",
                "no_search_results": "No search results found.",
                "filter_search": "Filter...",
                "collection_archive": "Collection archive",
                "activities": {
                    "title": "Activity",
                    "details": "Details",
                    "reset": "Reset",
                    "load_more": "Load more",
                    "no_results": "There are no activities for the specified filter.",
                    "no_more_results": "You have reached the end of activities for the specified filter.",
                    "actions": {
                        "created": "Created",
                        "deleted": "Deleted",
                        "updated": "Updated"
                    }
                },
                "settings": {
                    "title": "Settings"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=en.js.map